module.exports = __webpack_public_path__ + "img/circle2.3d26e1f3.png";